import * as yup from "yup";

export const autoPhoneFormat = (phoneNumber) => {
  if (phoneNumber?.slice(0, 2) == "02") {
    const value = phoneNumber
      ?.replace(/-/g, "")
      .replace(/(\d{2})(\d{4})(\d{4})/, "$1-$2-$3");
    return value;
  } else {
    const value = phoneNumber
      ?.replace(/-/g, "")
      .replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
    return value;
  }
};

export const evidenceCheck = (insertNum) => {
  const regsplitNum = insertNum
    .replace(/-/gi, "")
    .split("")
    .map(function (item) {
      return parseInt(item, 10);
    });
  if (regsplitNum.length === 10) {
    const regkey = [1, 3, 7, 1, 3, 7, 1, 3, 5];
    let regNumSum = 0;
    for (var i = 0; i < regkey.length; i++) {
      regNumSum += regkey[i] * regsplitNum[i];
    }
    regNumSum += parseInt((regkey[8] * regsplitNum[8]) / 10, 10);
    const regCheck =
      Math.floor(regsplitNum[9]) === (10 - (regNumSum % 10)) % 10;

    return regCheck;
  }
};
